import React from 'react';
import {
  Cog,
  Workflow,
  Factory,
  Cpu,
  Boxes,
  Globe,
} from 'lucide-react';

const industries = [
  {
    id: 'industrial-machinery',
    icon: Cog,
    title: 'Industrial Machinery',
    description:
      'Machinery manufacturers requiring local engineering, installation, commissioning or technical support for equipment delivered to customers in China.',
  },
  {
    id: 'production-lines',
    icon: Workflow,
    title: 'Production & Processing Lines',
    description:
      'Industrial production lines requiring mechanical, electrical, automation and commissioning support during installation and start-up.',
  },
  {
    id: 'manufacturing-plants',
    icon: Factory,
    title: 'Manufacturing Plants',
    description:
      'Technical personnel and project support for equipment installation, plant expansions, upgrades and production-related projects.',
  },
  {
    id: 'automation-control',
    icon: Cpu,
    title: 'Automation & Control Systems',
    description:
      'Projects involving PLC systems, industrial automation, sensors, actuators, drives and control equipment.',
  },
  {
    id: 'material-handling',
    icon: Boxes,
    title: 'Material Handling & Conveying Systems',
    description:
      'Installation supervision and technical support for conveyors, material handling equipment and integrated production systems.',
  },
  {
    id: 'oem-equipment',
    icon: Globe,
    title: 'OEM Equipment Projects',
    description:
      'Local engineering and technical support for international OEMs delivering machinery and industrial equipment to customers in China.',
  },
];

export const Gallery = () => {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="py-24 bg-white"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="mb-14">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Industries We Support
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-blue-800 mb-6"></div>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl leading-relaxed">
              Engineering and technical support for machinery, production systems and industrial projects across China.
            </p>
          </div>

          {/* Industries Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
            {industries.map((industry, index) => {
              const Icon = industry.icon;
              return (
                <div
                  key={industry.id}
                  data-testid={`industry-card-${industry.id}`}
                  className="group bg-white border border-gray-200 rounded-2xl p-7 md:p-8 hover:border-blue-300 hover:shadow-lg transition-all duration-300"
                  style={{ animationDelay: `${index * 80}ms` }}
                >
                  <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-blue-600 to-blue-800 rounded-xl shadow-md mb-5 group-hover:scale-105 transition-transform">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 leading-tight">
                    {industry.title}
                  </h3>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                    {industry.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
